import moment             from 'moment-timezone';
import { createSelector } from 'reselect';
import { getTimeZone }    from '../../helpers/timeUtils';
import {
    MessageDeliveryStatuses,
    MessagesFeed
}                         from '../../types';
import {
    MessagesContainerProps,
    MessageErrorState
}                         from './MessagesFeedTypes';

export const getMessagesFeed = (state, props: MessagesContainerProps) => state.messagesStore[`messages_${props.conversationId}`];

const getTwilioError = (state, props: MessagesContainerProps) => props.twilioError;

// TODO: all this logic should be somehow on backend
export const getWaitingForReplyStatus = createSelector(
    [getMessagesFeed, getTwilioError],
    (messagesFeed: MessagesFeed, twilioError: MessageErrorState) => {
        if (!messagesFeed || !messagesFeed.messages.length) {
            return false;
        }

        const lastMessage = messagesFeed.messages[messagesFeed.messages.length - 1];
        const daysPassed = moment.utc().diff(moment.utc(lastMessage.date_added).local().tz(getTimeZone()), 'days') + 1; // +1 accounts for 0 based numbering of dates in JS

        // check if the last message was a chat starter that was sent successfully within the last five days
        return (
            (lastMessage.message_template_id || lastMessage.templateId) &&
            (lastMessage.delivery_status === MessageDeliveryStatuses.SUCCESS || lastMessage.delivery_status === MessageDeliveryStatuses.IN_PROGRESS || lastMessage.delivery_status === MessageDeliveryStatuses.NEW) &&
            !twilioError &&
            daysPassed < 5
        );
    }
);



// WEBPACK FOOTER //
// ./src/sections/MessagesFeed/MessagesSelectors.ts